import { showModal, toggleShowHelpModal } from '../Slicers/modalSlice';
import { useDispatch } from 'react-redux';
import { showModal as showTrobber, toggleShow } from '../Slicers/waitSlicer';

/** Хук для работы с модальными окнами  */
const useModal = () => {
	const dispatch = useDispatch();

	function showError(text: string): void;
	function showError(text: string, title: string): void;
	function showError(text: string, title: string, traceId?: string): void;

	function showError(text: string, title?: string, traceId?: string): void {
		dispatch(
			showModal({
				type: 2,
				title: title || 'Ошибка',
				text,
				traceId,
			}),
		);
	}

	function showInfo(text: string): void;
	function showInfo(text: string, title: string): void;

	function showInfo(text: string, title?: string): void {
		dispatch(
			showModal({
				type: 0,
				title: title || 'Инфо',
				text,
			}),
		);
	}

	const showWaiting = (title?: string, type = 'std'): void => {
		dispatch(
			showTrobber({
				isWaiting: true,
				variant: type,
				title: title || 'Пожалуйста, подождите...',
			}),
		);
	};

	const setWaiting = (isShow = false): void => {
		dispatch(toggleShow({ isShow }));
	};

	const toggleShowHelp = (isFull: boolean) => {
		return dispatch(toggleShowHelpModal(isFull));
	};

	return {
		showError,
		showInfo,
		toggleShowHelp,
		showWaiting,
		setWaiting,
	} as const;
};

export default useModal;
